import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import {faFacebookF} from "@fortawesome/free-brands-svg-icons"
import { Nav } from 'react-bootstrap';
import { SocialMenu } from '@/constants/Menus';

export default ({withNames, ...props}) => {
	const menus = SocialMenu.map((itm, idx)=>{
		const icon = itm.icon;
		return <Nav.Item as="li" key={itm.name}>
			<Nav.Link href={itm.href} title={itm.name} target={itm.external?"_blank":undefined} {...itm.props}>
				{icon && <FontAwesomeIcon icon={icon} />} 
				<span className={withNames?"ml-1":"sr-only"}>{itm.name}</span>
			</Nav.Link>
		</Nav.Item>
	})
	return <Nav {...props}>
		{menus}
		{/* <Nav.Item as="li">
			<Nav.Link href="https://www.facebook.com/iqsac.com.pe" target="_blank">
				<FontAwesomeIcon icon={faFacebookF} /> <span className={withNames?"ml-1":"sr-only"}>Facebook</span>
			</Nav.Link>
		</Nav.Item> */}
		{/* <Nav.Item as="li">
			<Nav.Link eventKey="link-1">Link</Nav.Link>
		</Nav.Item>
		<Nav.Item as="li">
			<Nav.Link eventKey="link-2">Link</Nav.Link>
		</Nav.Item> */}
	</Nav>
}